module.exports = __webpack_public_path__ + "static/Muli-BoldItalic-dabeb1c83e2008d9769f13516e5eff48.woff2";